import axios, { type AxiosInstance } from 'axios';
import { PUBLIC_API_URL } from '$env/static/public';

export interface SearchServiceHit {
  fields: {
    distance: number[];
  };
  _id: string;
  _index: string;
  _score: number;
  _source: Record<string, unknown>;
}

export interface SearchServiceResponse {
  data: {
    hits: {
      hits: SearchServiceHit[];
    };
  };
}

export class SearchAPIService {
  private http: AxiosInstance;
  private readonly venueId: number;

  public constructor(venueId: number) {
    this.venueId = venueId;
    this.http = axios.create({
      baseURL: PUBLIC_API_URL,
      timeout: 10000,
    });
  }

  public async query(term: string, languageId: number): Promise<SearchServiceHit[]> {
    const endpoint = 'v2/locations/venueSearch';
    const params = {
      venue_id: this.venueId,
      q: term,
      language_id: languageId,
    };
    const results = await this.http.get<SearchServiceResponse>(endpoint, { params });
    return Promise.resolve(results.data.data.hits.hits);
  }
}
